import axios from "axios";
import { insertActivity } from "../actions/addActivity";
import { INSERT_ACTIVITY } from "../actions/actionTypes";

export const login = (email, password, domain) => {
  const base_url =
    process.env.NODE_ENV === "_development"
      ? "http://" + localStorage.domain + ".localhost:8003/api/"
      : process.env.REACT_APP_MULTITENANT === "true"
      ? "https://" + localStorage.domain + "." + "uppybook.com/api/"
      : process.env.REACT_APP_API_URL + "api/"; //TODO cenibook.com
  return new Promise((resolve, reject) => {
    let params = { email: email, password: password };

    axios
      .post(base_url + "login", params)
      .then((res) => {
        const data = res.data;
        console.log("data", data);
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const socialLogin = (accessToken) => {
  const base_url =
    process.env.NODE_ENV === "_development"
      ? "http://" + localStorage.domain + ".localhost:8003/api/"
      : process.env.REACT_APP_MULTITENANT === "true"
      ? "https://" + localStorage.domain + "." + "uppybook.com/api/"
      : process.env.REACT_APP_API_URL + "api/"; //TODO cenibook.com
  return new Promise((resolve, reject) => {
    let params = { accessToken };

    axios
      .post(base_url + "social-login", params)
      .then((res) => {
        const data = res.data;
        console.log("data", data);
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const addButtonService = (formData, domain, pageNumber) => {
  const base_url = getApiUrl(domain);
  // var formData = new FormData();
  // formData.append("content", data.fileupload);
  // formData.append("type", data.type);
  // formData.append("link", data.link);
  // formData.append("left", data.left);
  console.log("--", formData, domain, pageNumber);

  return new Promise((resolve, reject) => {
    // resolve({});

    //   // let params = { email: email, password: password };

    axios
      .post(base_url + "cenibook-pages/store/" + pageNumber, formData)

      .then((res) => {
        const data = res.data;
        console.log(" return data", data);
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const addButtonFormService = (sendData, domain, pageNumber) => {
  console.log("api----sendData", sendData, domain, pageNumber);
  // return;
  // const base_url = "https://" + domain + ".uppybook.com/api/";
  const base_url = getApiUrl(domain);
  console.log(
    'base_url + "cenibook-pages/store/" + pageNumber',
    base_url + "cenibook-pages/store/" + pageNumber
  );
  const formData = new FormData();
  formData.append("content", sendData.content);
  formData.append("button_type", sendData.button_type);
  formData.append("style", sendData.style);
  formData.append("top", parseInt(sendData.top));
  formData.append("left", parseInt(sendData.left));
  formData.append("width", parseInt(sendData.width));
  formData.append("height", parseInt(sendData.height));
  formData.append("show", parseInt(sendData.show));
  formData.append("status", parseInt(sendData.status));
  formData.append("sharing", parseInt(sendData.sharing));
  formData.append("description", sendData.description);
  console.log("formData", formData);
  return new Promise((resolve, reject) => {
    axios
      .post(base_url + "cenibook-pages/store/" + pageNumber, formData)
      .then((res) => {
        const data = res.data;
        console.log(" return data", data);
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const updateButtonService = (formData, domain, attributeNumber) => {
  const base_url = getApiUrl(domain);
  console.log("--", formData, domain, attributeNumber);

  return new Promise((resolve, reject) => {
    axios
      .post(base_url + "cenibook-pages/update/" + attributeNumber, formData)
      .then((res) => {
        const data = res.data;
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const deleteButtonService = (domain, attributeId) => {
  // const base_url = "https://" + domain + ".uppybook.com/api/";
  const base_url = getApiUrl(domain);
  ///api/cenibook-pages/delAttr/8985
  console.log("-- delete Attr", attributeId);

  return new Promise((resolve, reject) => {
    axios
      .post(base_url + "cenibook-pages/delAttr/" + attributeId)
      .then((res) => {
        const data = res.data;
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
function getApiUrl(domain) {
  return process.env.REACT_APP_MULTITENANT === "true"
    ? "https://" + domain + ".uppybook.com/api/"
    : process.env.REACT_APP_API_URL + "api/";
}
